export const companyInfo = {
  title: 'В цифрах',
  items: [
    {
      number: '2000+',
      title: 'Выполненных проектов',
      text: '',
    },
    {
      number: '180+',
      title: 'Сотрудников в компании',
      text: '',
    },
    {
      number: '20+',
      title: 'Лет на рынке',
      text: '',
    },
  ],
};

export const programmingLanguages = {
  title: 'Языки программирования и технологии',
  items: [
    {
      number: '',
      title: 'Языки программирования',
      text: 'Python, C#, TypeScript, Swift, Kotlin, PHP',
    },
    {
      number: '',
      title: 'Технологий и фреймворков',
      text: 'Django, Angular, ReactJS, Laravel, .NET Core',
    },
    {
      number: '',
      title: 'Расширенная реальность',
      text: 'MR, VR, AR, XR и 3D',
    },
  ],
};




// WEBPACK FOOTER //
// ./src/data/mockHomeNumbers.js